<edge-app-features [features]="features"></edge-app-features>
<edge-additional-features [additionalFeatures]="additionalFeatures"></edge-additional-features>
